// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__XUcq4","container":"styles_container__pW501","logo":"styles_logo__Zv7Xj","links":"styles_links__NlVMU","bottom":"styles_bottom__8gYx+"};